/**
 * Created by Pankaj on 29-nov-2019
 */

import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {RomanEmpireGameMode} from "../../gamemode/RomanEmpireGameMode";
import {RomanEmpireParsedGameData} from "../../server/data/RomanEmpireParsedGameData";
import {TweenLite} from "gsap";


export class REGenieReSpinIntroController extends FreespinIntroController {
    private _isRestoreGenieReSpin: boolean;
    private _isRestoreState: boolean;

    constructor(config: IScreenConfig, tweakEnabled?: boolean) {
        super(config, tweakEnabled);
    }

    protected calculateIsTriggered(data: RomanEmpireParsedGameData): boolean {
        this._isRestoreState = data.isRestoreState;
        this._isRestoreGenieReSpin = this._isRestoreState && data.mode == RomanEmpireGameMode.GENIE_RESPIN && data.numberOfRespinPlayed < 1;
        this._isFreespinWon = (data.mode == RomanEmpireGameMode.NORMAL) && (data.nextMode == RomanEmpireGameMode.GENIE_RESPIN);
        return this._isFreespinWon || this._isRestoreGenieReSpin;
    }

    public start(): void {
        const delay: number = this._isRestoreState ? 0 : 0.5;
        TweenLite.delayedCall(delay, () => {
            super.start();
        });
    }

    protected show(): boolean {
        super.show();
        return this.shouldShow();
    }

    protected shouldShow(): boolean {
        return this._isFreespinWon || this._isRestoreGenieReSpin;
    }
}